module.exports = __webpack_public_path__ + "static/media/VV 11.7d3e0b72.mp3";